export const REGION_OPTIONS = [
  { value: 'CN', label: '中国大陆' },
  { value: 'VN', label: '越南' },
  { value: 'TH', label: '泰国' },
  { value: 'ID', label: '印尼' },
  { value: 'MY', label: '马来西亚' },
  { value: 'PH', label: '菲律宾' },
  { value: 'SG', label: '新加坡' }
];

export const CURRENCY_OPTIONS = [
  { value: 'CNY', label: 'CNY' },
  { value: 'VND', label: 'VND' },
  { value: 'THB', label: 'THB' },
  { value: 'IDR', label: 'IDR' },
  { value: 'MYR', label: 'MYR' },
  { value: 'PHP', label: 'PHP' },
  { value: 'SGD', label: 'SGD' },
  { value: 'USD', label: 'USD' }
];

export const FEATURE_TYPE_OPTIONS = [
  { value: 'QUOTA', label: 'QUOTA' },
  { value: 'TEXT', label: 'TEXT' },
  { value: 'BOOL', label: 'BOOL' }
];

export const CYCLE_TYPE_OPTIONS = [
  { value: 'day', label: '日' },
  { value: 'week', label: '周' },
  { value: 'month', label: '月' },
  { value: 'year', label: '年' }
];

/** revision 额度周期：DAY/WEEK/MONTH/TOTAL（北京时间，周一起算） */
export const REVISION_PERIOD_OPTIONS = [
  { value: 'DAY', label: '每日' },
  { value: 'WEEK', label: '每周' },
  { value: 'MONTH', label: '每月' },
  { value: 'TOTAL', label: '累计' }
];

export const EXPORT_GROUP_OPTIONS = [
  { value: 'talent', label: '达人数据导出' },
  { value: 'order', label: '订单数据导出' },
  { value: 'email', label: '邮件记录导出' },
  { value: 'invite', label: '邀约记录导出' }
];

export type PermissionNode = {
  key: string;
  title: string;
  children?: PermissionNode[];
};

export const PERMISSION_TREE: PermissionNode[] = [
  {
    key: 'shopee',
    title: 'Shopee',
    children: [
      { key: 'shopee-shop-list', title: 'Shopee 店铺列表' },
      { key: 'shopee-shop-detail', title: 'Shopee 店铺详情' },
      { key: 'shopee-industry-list', title: 'Shopee 行业列表' },
      { key: 'shopee-product-list', title: 'Shopee 商品列表' },
      { key: 'shopee-product-detail', title: 'Shopee 商品详情' }
    ]
  },
  {
    key: 'amazon',
    title: 'Amazon',
    children: [
      { key: 'amazon-product-list', title: 'Amazon 商品列表' },
      { key: 'amazon-product-detail', title: 'Amazon 商品详情' },
      { key: 'amazon-shop-list', title: 'Amazon 店铺列表' },
      { key: 'amazon-category', title: 'Amazon 类目管理' }
    ]
  },
  {
    key: 'tiktok',
    title: 'TikTok',
    children: [
      { key: 'tiktok-creator-list', title: 'TikTok 达人列表' },
      { key: 'tiktok-creator-detail', title: 'TikTok 达人详情' },
      { key: 'tiktok-shop-list', title: 'TikTok 店铺列表' },
      { key: 'tiktok-video-list', title: 'TikTok 视频列表' }
    ]
  },
  {
    key: 'ops',
    title: '运营能力',
    children: [
      { key: 'ops-talent-square', title: '达人广场' },
      { key: 'ops-private-message', title: '私信' },
      { key: 'ops-email', title: '平台邮箱' },
      { key: 'ops-invite', title: '定向邀约' },
      { key: 'ops-script', title: '话术管理' },
      { key: 'ops-member', title: '成员管理' }
    ]
  }
];

/** 扁平化权限节点，供 Transfer 计数与标题查找。 */
export function flattenPermissionKeys(nodes: PermissionNode[]): string[] {
  const keys: string[] = [];
  const walk = (list: PermissionNode[]) => {
    list.forEach((n) => {
      if (n.children?.length) {
        walk(n.children);
      } else {
        keys.push(n.key);
      }
    });
  };
  walk(nodes);
  return keys;
}

export function findPermissionTitle(key: string, nodes: PermissionNode[] = PERMISSION_TREE): string {
  for (const n of nodes) {
    if (n.key === key) return n.title;
    if (n.children) {
      const found = findPermissionTitle(key, n.children);
      if (found) return found;
    }
  }
  return key;
}
